/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HospitalHistoryDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    description?: string;
    examinationId?: string;
    employeeId?: string;
    status?: HospitalHistoryDto.status;
}

export namespace HospitalHistoryDto {

    export enum status {
        DELETED = 'DELETED',
        ACTIVE = 'ACTIVE',
        NURSE_OPERATION = 'NURSE_OPERATION',
        ARCHIVED = 'ARCHIVED',
        PASSIVE = 'PASSIVE',
    }


}
